import { gql } from '@apollo/client';

const APP_FRAGMENT = gql`
  fragment BaseApp on App {
    id
    name
    data
  }
`;

export default APP_FRAGMENT;
